import React, { Component } from 'react';
import { FormattedMessage  } from 'react-intl'
import PropTypes from 'prop-types';
import { Modal, Input, Progress } from 'antd'

export class ConfirmDialog extends Component {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });

    this.props.onOk()
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <div>
        <Modal
          title={<FormattedMessage id={this.props.title}/>}
          open={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width = "30%"
        >          
          <p><FormattedMessage id={this.props.content}/></p>
        </Modal>
      </div>
    );
  }
}
const ConfirmPropTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
};
ConfirmDialog.propTypes = ConfirmPropTypes;

export class InputDeviceDialog extends Component {
  state = { visible: false, value:'' };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    var value = this.state.value;

    this.setState({
      visible: false,
      value: ''
    });

    this.props.onOk(value);
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      value: ''
    });
  };

  onChange = (e) => {
    this.setState({value: e.target.value});
  }

  render() {
    return (
      <div>
        <Modal
          title={<FormattedMessage id={this.props.title}/>}
          open={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width = "30%"
        >          
          <div>
            <FormattedMessage id={this.props.content}/>
            <Input placeholder="192.168.0.100" 
            value = {this.state.value}
            onChange = {(e) => this.onChange(e)}/>
          </div>
        </Modal>
      </div>
    );
  }
}
const InputDevicePropTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
};
InputDeviceDialog.propTypes = InputDevicePropTypes;

export class AddDevicesDialog extends Component {
  state = { visible: false, percent:0, deviceName: '', disableOk: true, disableCancel: false };

  showModal = (devicesArray) => {
    this.devCounter = 0;
    this.stopAdd = false;

    this.setState({
      visible: true
    }, () => {setTimeout(() => {this.updateProgress(devicesArray)}, 1000);});
  };

  updateProgress(devicesArray) {
    if(devicesArray === undefined || devicesArray.length === 0 || this.stopAdd)
    {
      return;
    }

    this.props.addRequest(devicesArray[this.devCounter]);

    this.setState((state, props) => ({
      deviceName: devicesArray[this.devCounter], percent: ((this.devCounter + 1) * 100 / devicesArray.length)
    }));

      this.devCounter++;
      if (this.devCounter < devicesArray.length )
      {
          setTimeout(() => {this.updateProgress(devicesArray)}, 500);
      }    
      else
      {
          this.setState({disableOk: false, disableCancel: true});
      }
  }

  handleOk = e => {
    this.setState({
      visible: false,
      percent: 0,
      deviceName: ''
    });

    this.props.onOk();
  };

  handleCancel = e => {
    this.stopAdd = true;

    this.setState({
      visible: false,
      percent: 0,
      deviceName: ''
    });
  };

  render() {
    return (
      <div>
        <Modal
          title={<FormattedMessage id={this.props.title}/>}
          open={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okButtonProps={{ disabled: this.state.disableOk }}
          cancelButtonProps={{ disabled: this.state.disableCancel }}
          width = "30%"
          closable={false}
          keyboard={false}
          maskClosable={false}
        >          
          <div>
            <label>{this.state.deviceName}</label>
            <Progress percent={this.state.percent} />
          </div>
        </Modal>
      </div>
    );
  }
}

const AddDevicesPropTypes = {
  addRequest: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired
};
AddDevicesDialog.propTypes = AddDevicesPropTypes;
